import { Route } from 'react-router-dom';
import { outOfNavRoutes, routes } from '../utils/constants/userRoutes';
import { Dashboard } from '../routes/dashboards/Dashboard';
import { Settings } from '../routes/settings/settings';
import { ProfileRouter } from '../routes/profile/ProfileRouter';
import { UserRouter as UsrRouter } from '../routes/users/UserRouter';
import { BaseUserRouter } from './BaseUserRouter';

/**
 * UserRouter component.
 * @component
 *
 * Router component for user operations.
 * @returns {ReactElement} The UserRouter component.
 */
export const UserRouter = () => (
  <BaseUserRouter
    outOfNavRoutes={outOfNavRoutes}
    dashboardComponent={<Dashboard />}
    dashboardPath={routes.DASHBOARD}
    profileComponent={<ProfileRouter />}
    settingsComponent={<Settings />}
    additionalRoutes={[
      <Route key="users" path={`${routes.USERS}/*`} element={<UsrRouter />} />
    ]}
  />
);
